export default __webpack_public_path__ + "static/media/background.4791eb57.jpg";